const invertedMessages = {
  'External identities should be certified with an average of once in a quarter':
    'external.dashboard.recommendations.tooltip',
  'Average User Manager Certifications':
    'external.dashboard.recommendations.certified',
  'Uncertified Active Users': 'external.dashboard.recommendations.uncertified',
  'Since last 12 months': 'external.dashboard.recommendations.sinceTime',
  Low: 'external.dashboard.recommendations.low',
  Medium: 'external.dashboard.recommendations.medium',
  High: 'external.dashboard.recommendations.high',
};

export default invertedMessages;
